/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// es
t.add("cart.tickets.no_available_tickets_for_seating", "No hay entradas disponibles para los asientos seleccionados.", "PayseraCartBundle", "es");
t.add("cart.tickets.no_available_tickets", "No hay entradas disponibles.", "PayseraCartBundle", "es");
t.add("paysera_cart.discount.invalid_code", "C\u00f3digo de descuento inv\u00e1lido", "PayseraCartBundle", "es");
})(Translator);
